import React from 'react'
import { localize } from '../../util/Localizer'
import { Row, Col } from 'react-flexbox-grid'
import RBSelectField from '../../controls/RBSelectField'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import InputField from '../../controls/InputField'
import PasswordField from '../../controls/PasswordField'
import ErrorMessage from '../../widgets/common/ErrorMessage'
import { PassTooltip } from '../../widgets/common/Tooltip'
import Tooltip from '../../controls/Tooltip'
import { Colors } from '../../theme'

const StepTwo = (props) => {
  const values = props.values
  const styles = {
    customWidth: {
      width: '100%'
    }
  }
  const toolTip = PassTooltip()
  const w = window.innerWidth
  return (
    <section className='activate activateStep2'>
      <Row>
        <Col xs={12}>
          <h3>{localize('pages.activate.stepTwo.title')}</h3>
          <p>{localize('pages.activate.stepTwo.prompt')}</p>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={9} lg={6}>
          <form>
            <PasswordField
              id='temporaryPassword'
              type='password'
              fullWidth
              floatingLabelText={w < 365 ? localize('pages.activate.stepTwo.tempPassword.responsive') : localize('pages.activate.stepTwo.tempPassword')}
              defaultValue={values.temporaryPassword}
              onChange={props.handleInputChange}
              onBlur={props.validate}
            />
            <div className='tooltipInput'>
              <PasswordField
                id='password'
                type='password'
                fullWidth
                floatingLabelText={w < 365 ? localize('pages.activate.stepTwo.password.responsive') : localize('pages.activate.stepTwo.password')}
                defaultValue={values.password}
                onChange={props.handleInputChange}
                errorText={values.invalidPassLength ? values.invalidPassLength : values.confirmPassError}
                onBlur={props.validate}
                adornment={
                  <Tooltip title={toolTip} placement="right-end">
                    <IconButton tabIndex={-1} >
                      <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
                    </IconButton>
                  </Tooltip>
                }
              />

            </div>

            <PasswordField
              id='confirmPass'
              type='password'
              fullWidth
              floatingLabelText={localize('pages.activate.stepTwo.confirmPass')}
              defaultValue={values.confirmPass}
              onChange={props.handleInputChange}
              errorText={values.noConfirmPass ? values.noConfirmPass : values.confirmPassError}
              onBlur={props.validate}
            />
            <InputField
              id='email'
              type='email'
              fullWidth
              floatingLabelText={localize('pages.activate.stepTwo.email')}
              defaultValue={values.email}
              onChange={props.handleInputChange}
              errorText={values.invalidEmail ? values.invalidEmail : values.confirmEmailError}
              onBlur={props.validate}
            />
            <InputField
              id='confirmEmail'
              type='email'
              fullWidth
              floatingLabelText={localize('pages.activate.stepTwo.confirmEmail')}
              defaultValue={values.confirmEmail}
              onChange={props.handleInputChange}
              errorText={values.noConfirmEmail ? values.noConfirmEmail : values.confirmEmailError}
              onBlur={props.validate}
            />

            <RBSelectField
              id='securityQuestionsDropdown'
              label={localize('pages.activate.stepTwo.securityQuestion')}
              fullWidth
              selected={values.securityQuestion}
              sendValues={props.handleDropdownChange}
              style={styles.customWidth}
              data={props.questions}
            />

            <InputField
              fullWidth
              id='securityAnswer'
              type='text'
              floatingLabelText={localize('pages.activate.stepTwo.securityAnswer')}
              defaultValue={values.securityAnswer}
              onChange={props.handleInputChange}
              errorText={false}
              onBlur={props.validate}
            />
            <ErrorMessage error={props.pageErrors} />
          </form>
        </Col>
      </Row>
    </section>
  )
}

export default StepTwo



// WEBPACK FOOTER //
// ./src/widgets/activate/StepTwo.js